"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
import { Phone, Mail } from "lucide-react";
export default function Hero() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!heroRef.current) return;
      const {
        clientX,
        clientY
      } = e;
      const {
        innerWidth,
        innerHeight
      } = window;
      const xPercent = (clientX / innerWidth - 0.5) * 20;
      const yPercent = (clientY / innerHeight - 0.5) * 20;
      setMousePosition({
        x: xPercent,
        y: yPercent
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <>
      <style>{`
        html {
          scroll-behavior: smooth;
        }
      `}</style>
      
      <section ref={sectionRef} className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-dark-background text-foreground-dark">
        {}
        <div ref={heroRef} className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-200 ease-out" style={{
        backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1510319/img/hero_home_sale_background.png)",
        transform: `translate(${mousePosition.x}px, ${mousePosition.y}px) scale(1.1)`
      }} aria-hidden="true" />

        {}
        <div className="absolute inset-0 bg-dark-background/60" aria-hidden="true" />

        {}
        <div className="relative z-10 flex max-w-4xl flex-col items-center px-6 text-center">
          {}
          <h1 className={`font-display text-5xl font-bold leading-tight text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:text-6xl lg:text-7xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: "0ms"
        }}>
            Sell Your Home Fast for Cash
          </h1>

          {}
          <p className={`mt-6 max-w-2xl text-lg leading-relaxed text-white/90 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] md:text-xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: "100ms"
        }}>
            Nationwide service with no fees. We cover title, closing, and transfer costs so you walk away with more cash in hand.
          </p>

          {}
          <div className={`mt-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: "200ms"
        }}>
            <Button asChild size="lg" className="bg-primary px-8 py-4 text-lg font-semibold text-foreground shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.03] hover:bg-primary-hover hover:shadow-strong focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-dark-background">
              <Link to="#contact">Get Your Cash Offer</Link>
            </Button>
          </div>

          {}
          <div className={`mt-8 glass-effect px-8 py-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: "300ms"
        }}>
            <p className="mb-4 text-lg font-semibold text-white">Contact Thai Eang</p>
            <div className="flex flex-col gap-3 sm:flex-row sm:gap-6">
              <Link to="tel:+12063387815" className="group flex items-center gap-2 text-foreground transition-all duration-[var(--duration-fast)] hover:text-primary-dark hover:scale-[1.02]" aria-label="Call Thai Eang at +1 206-338-7815">
                <Phone className="size-5 text-primary-dark transition-transform duration-[var(--duration-fast)] group-hover:scale-110" />
                <span className="text-base font-medium">+1 206-338-7815</span>
              </Link>
              <Link to="mailto:thai.eang00@gmail.com" className="group flex items-center gap-2 text-foreground transition-all duration-[var(--duration-fast)] hover:text-primary-dark hover:scale-[1.02]" aria-label="Email Thai Eang at thai.eang00@gmail.com">
                <Mail className="size-5 text-primary-dark transition-transform duration-[var(--duration-fast)] group-hover:scale-110" />
                <span className="text-base font-medium">thai.eang00@gmail.com</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>;
}